exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "footer[data-v-1e4c4f9e]{font-size:.8rem;width:100%;position:fixed;height:30px;bottom:0;background-color:#222;color:#fff;text-align:right;padding-top:10px;z-index:10}p[data-v-1e4c4f9e]{margin-right:1rem;margin-bottom:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1e4c4f9e","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/Footer.vue
// module id = 4lPJ
// module chunks = 23